<template>
  <div id="inspection-form">
    <div class="main">
      <div class="title">
        <img src="../../assets/images/LTicon.png" alt="" />
        <span>角色管理</span>
      </div>
      <div class="content">
        <div class="query-form">
          <el-form class="form" ref="form" :inline="true" :model="requestParam">

            <el-form-item label="角色名称：">
              <el-input v-model="requestParam.roleName" placeholder="请输入角色名称" clearable>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="query-button">
            <el-button type="primary" icon="el-icon-search" @click="formQuery">查询</el-button>
            <el-button type="primary" :class="isStringInArray('btnNewRole') ? '' : 'btnShowAuthority'" icon="el-icon-plus" @click="createInspection">新建角色</el-button>
          </div>
        </div>

        <el-table v-loading='dataLoading' element-loading-text="加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.3)" :cell-style="{ color: '#AED6FF', fontSize: '12px' }"
          :header-cell-style="{ color: '#e8f4ff', fontSize: '14px' }" class="table" :data="tableData" default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" row-key="id">
          <div slot="empty">
            <div v-if="tableData.length == 0">
              <div class="empty-data-view">
                <div class="tableText">
                  {{ dataLoading ? '' : '暂无数据' }}
                </div>
              </div>
            </div>
          </div>

          <el-table-column align="center" label="序号" type="index" :index="getIndex" width="60px">
          </el-table-column>
          <el-table-column align="center" prop="roleName" label="角色名称" width="300px">
          </el-table-column>
          <el-table-column align="center" prop="roleCode" label="角色编码">
          </el-table-column>
          <el-table-column align="center" prop="enableFlage" label="状态">
            <template slot-scope="scope">
              {{ scope.row.enableFlage == 0 ? '启用' : '停用' }}
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop="createBy" label="创建人">
          </el-table-column> -->
          <el-table-column align="center" prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column align="center" prop="data" fixed="right" label="操作" width="220px">
            <template  slot-scope="scope">
              <el-button :class="isStringInArray('btnEdit') ? '' : 'btnShowAuthority'" @click="editDialog(scope.row)" type="text">编辑</el-button>
              <span  :class="isStringInArray('btnEdit') ? '' : 'btnShowAuthority'" > | </span>
              <el-button :class="isStringInArray('btnTableType') ? '' : 'btnShowAuthority'" @click="typeDialogBtn(scope.row)" type="text">
              {{  scope.row.enableFlage == 0 ? '停用' : '启用' }}
              </el-button>
              <span  :class="isStringInArray('btnTableType') ? '' : 'btnShowAuthority'" > | </span>
              <el-button :class="isStringInArray('btnBindUsers') ? '' : 'btnShowAuthority'" @click="bindingUser(scope.row)" type="text">绑定用户</el-button>
              <span  :class="isStringInArray('btnBindUsers') ? '' : 'btnShowAuthority'" > | </span>
              <el-button :class="isStringInArray('btnDelete') ? '' : 'btnShowAuthority'" @click="deleteDialog(scope.row)" type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <button class="home-page" @click="homePage">首页</button>
          <el-pagination :current-page="requestParam.pageNum" :page-sizes="[10, 20, 30, 40]"
            layout="prev, pager, next, sizes,slot" prev-text="上一页" next-text="下一页" :total="total" background
            @size-change="changeSize" @current-change="changeCurrent">
          </el-pagination>
          <button class="tail-page" @click="tailPage">尾页</button>
          <div class="jump-pagination">
            <span class="text">跳至</span>
            <el-input v-model.number="inputValue" size="mini" maxlength="2" class="pagination-input" @input="handleEdit"
              @change="inputValueChange"></el-input>
            <span class="text">页</span>
            <button class="confirm" @click="confirm">确定</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog @close="closeDialog('form')" :title="dialogTotalType == 0 ? '新建角色' : '编辑角色'" :visible.sync="dialogVisible"
      width="751px">
      <div class="dialog-content">
        <div class="form-title"></div>
        <el-form class="" ref="form" :rules="rules" :model="form" label-width="100px">
          <el-form-item label="角色名称:" prop="roleName" class="myDialogForm">
            <el-input v-model.trim="form.roleName" class="myFormItem" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色编码:" prop="roleCode" class="myDialogForm">
            <el-input v-model.trim="form.roleCode" class="myFormItem" placeholder="请输入角色编码"></el-input>
          </el-form-item>
          <!-- <el-form-item label="是否启用:" prop="enableFlage" class="myDialogForm">
            <el-select v-model="form.enableFlage" :popper-append-to-body="false" clearable placeholder="请选择是否启用">
              <el-option label="是" :value="0"></el-option>
              <el-option label="否" :value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="菜单权限:" prop="roleCode" class="myDialogForm">
            <div class="treeBody">
              <div class="treeTitle">
                <div class="titleChecked">
                  <el-checkbox @change="checkedChange" v-model="checked">展开/折叠</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox @change="allCheckedChange" v-model="allChecked">是否全选</el-checkbox>

                </div>

              </div>
              <!-- <el-tree v-if="dialogTotalType==0" :default-expand-all="checked" :default-checked-keys="menuIds" node-key="id" ref="tree"
                :data="treeData" highlight-current :props="defaultProps" @check="handleCheck" show-checkbox >
              </el-tree> -->
              <el-tree  :default-expand-all="checked" :default-checked-keys="menuIds" node-key="id" ref="tree"
                :data="treeData" highlight-current :props="defaultProps" @check="handleCheck" show-checkbox :check-strictly="true" >
              </el-tree>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addDialogVisible('form')">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="删除" :visible.sync="deleteVisible" width="436px">
      <div class="delete">确定要删除该角色吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteInspectionForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改状态" :visible.sync="typeVisible" width="436px">
      <div class="typeDialog">
        <div class="typeDialogItem1">{{ tableType==0 ? '确定启用该角色?':'确定停用该角色?'}} </div>
        <div class="typeDialogItem2">{{ tableType==1 ? '角色被停用后该角色下绑定的用户将认修改为普通用户的角色!':''}} </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="typeVisible = false">取 消</el-button>
        <el-button type="primary" @click="tableTypeModify">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { inspectionFormApi } from "@/api/inspectionForm.js";
import { getTableTree, roleList, roleAdd, roleUpdate, roleDelete, getMenuTreeList,roleType } from "@/api/eios.js"

export default {
  name: "",
  data() {
    return {
      dataLoading: false,
      tableData: [],
      requestParam: {
        pageNum: 1,
        pageSize: 10,
        roleName: "",
      },
      menuIds:[],
      form: {
        roleName: '',
        roleCode: '',
        // enableFlage: '',
        menuIds: []

      },
      rules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
        roleCode: [
          { required: true, message: '请输入角色编码', trigger: 'blur' },
        ],
        enableFlage: [
          { required: true, message: '请选择是否启用', trigger: 'change' },
        ],
        // provinceId: [
        //   { required: true, message: '请选择省', trigger: 'change' }
        // ],
      },
      total: 0,
      inputValue: "",
      deleteVisible: false,
      dialogVisible: false,
      dialogVisible2: false,
      typeVisible:false,
      id: "",
      dialogTotalType: 0,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'menuName',
        id: 'id'
      },
      expandAll: false,
      checked: false,
      allChecked: false,
      parentId:[],
      strictly:true,
      tableType:'',
      id:'',
      authorityListBtn:[],
    };
  },
  created() {
    this.$store.commit('increment', '系统设置')
    this.$store.commit('selectChild', '角色管理')
    this.$store.commit("selectChildren", "");
    this.dataLoading = false

  },

  mounted() {
    this.queryOperation()
    this.getMenu()
    this.authorityListBtn=sessionStorage.getItem('roleInfo')
  },
  watch: {
    // 如果只需要监听对象中的一个属性值，则可以做以下优化：使用字符串的形式监听对象属性：
    "requestParam.pageNum": {
      // 执行方法
      handler(newValue, oldValue) {
        this.inputValue = newValue;
      },
     deep:true,
      immediate: true, // 第一次改变就执行
    },
  },
  methods: {
      //按钮权限
      isStringInArray(str) {
      if (this.authorityListBtn) {
        let list = this.authorityListBtn.includes(str);
        return list
      } else {
        return false
      }
    },
    //修改状态
    tableTypeModify(){
      let obj ={
        id:this.id,
        tableType:this.tableType
      }
      roleType(obj).then(res=>{
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: "success",
            duration: 3000,
            customClass: "messageText",
          });
          this.typeVisible = false;
          this.queryOperation();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 3000,
            customClass: "messageText",
          });
        }
      })


    },
    //绑定用户
    bindingUser(el) {
      this.$router.push({
        name: 'RoleAdminSun',
        query: { roleId: el.id }
      })
    },
    //是否全选
    allCheckedChange(value) {
      this.$refs.tree.setCheckedNodes(value ? this.treeData : []);
      // let expanded=value
      // this.checked=value
      // this.$refs.tree.store._getAllNodes().forEach(v => v.expanded = expanded);
      if(this.allChecked){
          this.traverseTree(this.treeData)
          this.$refs.tree.setCheckedKeys(this.menuIds);
        }else{
          this.form.menuIds=[]
          this.menuIds=[]
        }
        console.log("allChecked",this.menuIds);
    },
    traverseTree(data) {
      data.forEach(item =>{
        this.menuIds.push(item.id)
          this.form.menuIds.push(item.id)
          this.menuIds.push(item.id)
          if(item.children&&item.children.length > 0){
            console.log(item.children);
            this.traverseTree(item.children)
          }
        })
    },
    //是否展开
    checkedChange(expanded = true) {
      this.$refs.tree.store._getAllNodes().forEach(v => v.expanded = expanded);
      // this.traverseTree(this.treeData)
      // console.log("00000000");
    },

    handleCheck(checkedNode, checkedNodes) {
      this.strictly=true
      // this.checkedKeys = checkedNodes.map(node => node.id);
      console.log(checkedNode, checkedNodes);
      // console.log(checkedNodes.checkedNodes.map(node => node.id));
      this.form.menuIds = checkedNodes.checkedKeys
      this.menuIds = checkedNodes.checkedKeys
      this.parentId=checkedNodes.halfCheckedKeys
    
    },

    getMenu() {
      getMenuTreeList().then(res => {
        this.treeData = res.data
      })
    },

    isOverflow(content) {
      // const lineHeight = 16;
      const numLines = Math.ceil(content.length / 42); // 每行大概显示42个字符
      // console.log("====>",numLines);
      return numLines >= 3;
    },
    //序号
    getIndex(index) {
      return (this.requestParam.pageNum - 1) * this.requestParam.pageSize + index + 1;
    },
    closeDialog(form) {
      this.form = this.$options.data().form
      this.menuIds=[]
      this.parentId=[]
      this.$refs.tree.setCheckedKeys([]);
      this.$refs[form].resetFields();
      this.checked = false
      this.allChecked = false
      this.checkedChange(false)
    },
    //新增/修改
    addDialogVisible(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.form.menuIds=this.form.menuIds.concat(this.parentId)
          console.log("~~~~~~~~@@~~~~~~~~",this.form);
          let func = this.dialogTotalType == 0 ? roleAdd(this.form) : roleUpdate(this.form)
          func.then(res => {
            if (res.code == 200) {
              this.dialogVisible = false
              this.$message({
                message: res.message,
                type: 'success',
                duration: 3000,
                customClass: "messageText",
              });
              this.queryOperation()
            } else {
              this.$message({
                message: res.message,
                type: 'error',
                duration: 3000,
                customClass: "messageText",
              });
            }
          })
        } else {
          return false
        }
      });
    },
    //新增弹窗打开
    createInspection() {
      this.strictly=true
      this.dialogTotalType = 0
      // this.checked=true
      this.dialogVisible = true;
    },
    editDialog(el) {
      this.id = el.id
      // this.checked=true
      this.strictly=false
      this.dialogVisible = true
      this.form = Object.assign({}, el);
      this.dialogTotalType = 1
      getTableTree(el.id).then(res => {
        this.form.menuIds = res.data.map(node => node.id)
        this.menuIds = res.data.map(node => node.id)
      })
      // console.log( this.form);
      // this.$refs.tree.setCheckedKeys(this.form.menuIds);
    },
    typeDialogBtn(el){
      this.id=el.id
      this.tableType= el.enableFlage==0 ? 1:0
      // if(el.enableFlage==0){
      //   this.tableType=1
      // }else{
      //   this.tableType=0
      // }
      console.log(this.id ,this.tableType);
      this.typeVisible=true

    },
    deleteDialog(item) {
      this.id = item.id;
      this.deleteVisible = true;
    },
    formQuery() {
      this.requestParam.pageNum = 1;
      this.queryOperation();
    },
    queryOperation() {
      this.dataLoading = true
      roleList(this.requestParam).then(res => {
        this.dataLoading = false
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total
        }
      })


    },
    handleEdit(e) {
      let value = e.replace(/[^\d]/g, ""); // 只能输入数字
      value = value.replace(/^0+(\d)/, "$1"); // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      this.inputValue = value
    },

    //页数输入
    inputValueChange() {
      const lastPage = Math.ceil(this.total / this.requestParam.pageSize);
      if (this.inputValue < 1) {
        this.inputValue = 1;
      } else {
        this.inputValue =
          this.inputValue < lastPage ? this.inputValue : lastPage;
      }
    },
    //首页
    homePage() {
      this.requestParam.pageNum = 1;
      this.queryOperation();
    },
    //尾页
    tailPage() {
      const lastPage = Math.ceil(this.total / this.requestParam.pageSize);
      this.requestParam.pageNum = lastPage;
      this.queryOperation();
    },
    confirm() {
      this.requestParam.pageNum = this.inputValue;
      this.queryOperation();
    },
    changeSize(pageSize) {
      this.requestParam.pageSize = pageSize;
      this.queryOperation();
    },
    changeCurrent(pageNum) {
      this.requestParam.pageNum = pageNum;
      this.queryOperation();
    },
    //删除
    deleteInspectionForm() {
      roleDelete(this.id).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: res.message,
            type: "success",
            duration: 3000,
            customClass: "messageText",
          });
          this.deleteVisible = false;
          this.queryOperation();
        } else {
          this.$message({
            message: res.message,
            type: "error",
            duration: 3000,
            customClass: "messageText",
          });
        }
      });
    },

  },

};
</script>
<style scoped>
#inspection-form {
  width: 100%;
  min-height: 781px;
  background: url("../../assets/images/rightBG.png") no-repeat;
  background-position: left top;
  background-size: cover;
  font-size: 16px;
}

.main {
  width: 100%;
  padding: 20px 26px 28px 25px;
  box-sizing: border-box;
}

.title {
  font-size: 16px;
  font-family: "Arial", sans-serif;
  color: #e8f4ff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.title img {
  width: 20px;
  height: 20px;
}

.title span {
  font-size: 16px;
  font-family: "Arial", sans-serif;
  color: #e8f4ff;
  margin-left: 10px;
}

/* 查询表单 */
.query-form {
  padding: 16px 20px;
  background-color: #061b45;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.query-button {
  display: flex;
  /* justify-content: space-between; */
}

.query-button ::v-deep .el-button {
  height: 35px;
  padding: 0 20px;
  background-color: #176ad2;
  text-align: center;
  line-height: 35px;
  font-size: 12px;
  color: #e8f4ff;
  border: 0;
}

.form ::v-deep .el-form-item {
  margin: 0 16px 12px 0;
  /* width: 100%; */
}

.form ::v-deep.el-form-item__label {
  width: 61px;
  padding-right: 0;
  color: #e8f4ff;
  font-size: 12px;
  text-align: left;
}

/* input */
.form ::v-deep .el-input .el-input__inner {
  height: 35px;
  width: 180px;
  background-color: #061b45;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;
}

.form ::v-deep .el-input .el-input__inner {
  height: 35px;
  width: 180px;
  background-color: #061b45;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;
}

::v-deep .el-input .el-input__inner {
  background-color: #061b45;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;
}

.form ::v-deep .el-input input::placeholder {
  font-size: 12px;
  color: #6180a8;
}

::v-deep .el-input input::placeholder {
  font-size: 12px;
  color: #6180a8;
}

::v-deep .el-textarea .el-textarea__inner::placeholder {
  font-size: 12px;
  color: #6180a8;
}

/* 下拉选择框 */
.el-select>>>.el-select-dropdown {
  background: #041c4c;
  border: 1px solid #09295b;
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.hover {
  background: #041c4c;
  color: #fff;
}

::v-deep .el-select-dropdown__item {
  color: #aed6ff;
}

::v-deep .el-select-dropdown__item.selected {
  color: #fff;
}

.el-select ::placeholder {
  color: #6180a8;
}

.el-select {
  width: 100%;
}

/* 表格 */
/* 设置表头的背景颜色 */
.table ::v-deep thead th {
  background-color: #09224b;
  color: #e8f4ff;
  font-size: 14px;
}

.table ::v-deep tbody tr {
  font-size: 12px;
  color: #aed6ff;
}

/* 设置表格内的背景颜色 */
::v-deep.el-table tbody tr:nth-child(odd) {
  background-color: #071734;
}

::v-deep.el-table tbody tr:nth-child(even) {
  background-color: #071734;
}

::v-deep.el-table {
  border: 2px solid #081f42 !important;
  position: relative;
}

::v-deep.el-table th {
  border: 1px solid #09234e !important;
}

::v-deep.el-table td {
  border: 1px solid #0d2247 !important;
}

.table ::v-deep .el-table__body tr:hover>td {
  background-color: #081f42 !important;
}

::v-deep .el-table::before {
  height: 0px;
}

::v-deep .el-table__fixed-right::before {
  height: 0px;
}

::v-deep .el-table__body tr.hover-row>td.el-table__cell {
  background-color: #081f42 !important;
}

/* 暂无数据 */
::v-deep .el-table__body-wrapper {
  background: #071734;
}

::v-deep .el-table__empty-text {
  color: aliceblue;
  line-height: 150px;
}

.response-message {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.operate span {
  margin: 0 3px;
}

.tooltip {
  text-align: center;
}

/* 分页 */
.pagination {
  margin-top: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination ::v-deep .el-pagination {
  padding-left: 0;
}

.home-page,
.tail-page {
  width: 60px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #0b2653;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Arial", sans-serif;
  color: #92b5da;
  text-align: center;
  line-height: 30px;
  margin-right: 5px;
}

.home-page:hover,
.tail-page:hover {
  background-color: #176ad2;
  box-sizing: border-box;
  color: #ffffff;
}

.home-page:checked,
.tail-page:checked {
  background-color: #176ad2;
  box-sizing: border-box;
  color: #ffffff;
}

.el-pagination>>>.btn-prev,
.el-pagination>>>.btn-next {
  width: 60px;
  height: 30px;
  border: 1px solid #0b2653;
  background-color: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 30px;
  padding: 0;
  text-align: center;
}

.el-pagination>>>.el-pager li {
  width: 35px;
  height: 30px;
  background: rgba(255, 255, 255, 0);
  color: #d7d7d7;
  border-radius: 2px;
  border: 1px solid #0b2653;
  margin-right: 5px;
}

.jump-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-input {
  height: 30px;
  width: 35px;
  margin: 0 10px;
}

.pagination-input>>>.el-input__inner {
  background-color: rgba(255, 255, 255, 0);
  border: 1px solid #0b2653;
  padding: 0;
  text-align: center;
  color: #92b5da;
}

.pagination ::v-deep.el-select .el-input__inner {
  height: 30px;

  color: #92b5da;
  border: 1px solid #0b2653;
  background-color: rgba(255, 255, 255, 0);
}

.pagination ::v-deep .el-pagination__sizes {
  margin-right: 0;
}

.jump-pagination .text {
  color: #92b5da;
  line-height: 30px;
}

.confirm {
  width: 60px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid rgba(228, 228, 228, 0);
  background-color: #176ad2;
  font-family: "微软雅黑", sans-serif;
  color: #d7d7d7;
  text-align: center;
  line-height: 30px;
  padding: 0;
  margin-left: 5px;
}

/* 弹窗 */
::v-deep .el-dialog {
  background-color: #071734;
}

::v-deep .el-dialog .el-dialog__header {
  background-color: #05153a;
  border-bottom: 1px solid #09295b;
}

::v-deep .el-dialog__title {
  font-size: 16px;
  color: #c9d4f1;
}

::v-deep .el-dialog__body {
  padding: 0;
}

::v-deep .el-dialog__footer {
  padding-top: 0;
}

.form-title {
  font-family: "Arial Bold", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  color: #c9d4f1;
  font-size: 16px;
  margin-bottom: 16px;
}

.dialog-content {
  margin: 18px 50px 0 47px;

}

.details-form ::v-deep.el-form-item__label {
  width: 69px;
  color: #c9d4f1;
  font-size: 12px;
  text-align: right;
  margin-right: 28px;
}

.details-form ::v-deep .el-input .el-input__inner {
  width: 447px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: rgba(255, 255, 255, 0);
}

.details-form ::v-deep .el-textarea .el-textarea__inner {
  width: 447px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: rgba(255, 255, 255, 0);
}

.interval {
  width: 654px;
  height: 1px;
  background-color: #06224e;
  margin-bottom: 16px;
}

.details-form .default-inspection ::v-deep .el-input .el-input__inner {
  width: 651px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: rgba(255, 255, 255, 0);
}

.details-form .selected-inspection::v-deep .el-input .el-input__inner {
  width: 651px;
  color: #c9d4f1;
  font-size: 12px;
  border: 1px solid #06224e;
  background-color: #041c4c;
}

.default-inspection ::v-deep .el-select-dropdown__item {
  height: 35px;
  background-color: rgba(255, 255, 255, 0);
  border-bottom: 1px solid #06224e;
  box-sizing: border-box;
  font-size: 12px;
  color: #aed6ff;
  font-weight: 300;
}

.details-form ::v-deep .el-select-dropdown__item {

  display: flex;
  justify-content: space-between;
}

::v-deep .el-popper[x-placement^="bottom"] .popper__arrow::after {
  top: 0;
  border-bottom-color: #041c4c;
}

.delete {
  font-size: 16px;
  font-weight: 700;
  color: #c9d4f1;
  margin: 42px 0 64px 39px;
}
.typeDialog {
  font-size: 16px;
  font-weight: 700;
  color: #c9d4f1;
  margin: 40px 0 40px 39px;
}
.typeDialogItem1{
  margin-bottom: 10px;

}



.dialog-footer {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #000;
}

.dialog-footer button {
  width: 106px;
  height: 36px;
  background: #2142a1;
  border: 0;
  color: #ffffff;
  font-size: 13px;
}

.tooltip {
  max-width: 600px;
  /* 设置最大宽度 */
  line-height: 20px;
}


::v-deep .el-icon-arrow-right:before {
  color: #aed6ff;
  font-size: 16px;
}

::v-deep .el-textarea {
  width: 100%;
}

.place {
  width: 100%;
}

.myDialogForm>>>.el-form-item__label {
  color: #e8f4ff;
}

.myFormItem>>>.el-input__inner {

  background-color: #071734;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;

}

.myFormItem>>>.el-textarea__inner {

  background-color: #071734;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;

}

/* select选择器 */
.el-select>>>.el-input__inner {
  background: #071734;
  border: 1px solid #09295b;
  font-size: 12px;
  color: #aed6ff;
}

/* tree
   */

::v-deep .el-tree {
  background: #071734;
  color: #6180a8;
}

::v-deep .el-tree-node {
  background: #071734 !important;
}

::v-deep .is-current {
  background: #071734 !important;
  /* color: #FFC74A; */
}

::v-deep .is-checked {
  background: #071734 !important;
  /* color: #FFC74A; */
}

::v-deep .el-tree-node__content:hover {
  background: #071734;
  /* color: #FFC74A; */
}

::v-deep .el-tree-node__content:focus {
  background: #071734 !important;
}

::v-deep.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #071734;
}

::v-deep .el-tree-node {
  background-color: #071734;

}

::v-deep .el-tree-node:focus>.el-tree-node__content {
  background-color: #071734;

}

.treeBody {
  border: 1px solid #09295b;
}

.treeTitle {
  display: flex;
}

.titleChecked {
  margin: 0 10px;
  color: #aed6ff;
}

::v-deep .el-checkbox__label {
  color: #6180a8;

}

/* tableLoading字体设置 */
::v-deep .el-icon-loading {
  font-size: 18px;

}

::v-deep .el-loading-text {
  font-size: 18px;

}

.tableText {
  font-size: 16px;
  color: #aed6ff;

}
::v-deep .el-dialog__body{
  max-height: 800px;
  overflow: auto;
}
::v-deep .el-dialog__body::-webkit-scrollbar {
  width: 10px;
  /* 设置滚动条高度 */
  background-color: #09234E;
  /* 设置滚动条背景色 */
}

::v-deep .el-dialog__body::-webkit-scrollbar-thumb {
  background-color: #003d74;
  /* 设置滚动条滑块颜色 */
  border-radius: 5px;
  /* 设置滚动条滑块的圆角 */
}
</style>

